module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-boards', {
    attrs: {
      "md-auto": true,
      "md-infinite": true,
      "md-duration": 10000,
      "md-swipeable": true
    }
  }, [_c('md-board', {
    attrs: {
      "id": "slide1"
    }
  }, [_c('img', {
    staticClass: "onboarding-image",
    attrs: {
      "src": require("../assets/onboarding1.png")
    }
  })]), _vm._v(" "), _c('md-board', {
    attrs: {
      "id": "slide2"
    }
  }, [_c('img', {
    staticClass: "onboarding-image",
    attrs: {
      "src": require("../assets/onboarding2.png")
    }
  })]), _vm._v(" "), _c('md-board', {
    attrs: {
      "id": "slide3"
    }
  }, [_c('img', {
    staticClass: "onboarding-image",
    attrs: {
      "src": require("../assets/onboarding3.png")
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee87eb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Onboarding.vue
// module id = 340
// module chunks = 1